import { Security } from "@singularsystems/neo-core";

interface IAppUserClaims {
    /** Gets the user id. */
    sub: string;
}

export default class AppUser extends Security.OidcUser {

    /** Gets the users claims. */
    public get claims(): IAppUserClaims {
        return this.userData.profile;
    }

    public get userName(): string {
        return super.userName ?? this.userData.profile["http://schemas.xmlsoap.org/ws/2005/05/identity/claims/name"];
    }
}